
import dayjs from 'dayjs';

const dateInterfere = (date, quantity, interval) => {
  return dayjs(date)
    .add(quantity, interval);
}

export default dateInterfere;
